import React, { useState, useRef } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { Bs1CircleFill, Bs2CircleFill, Bs3CircleFill, Bs4CircleFill } from 'react-icons/bs';
import { FaCheck } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';

const AddNewEmployee = ({setLoading}) => {
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [formData, setFormData] = useState({
        name: '',
        designation: '',
        h_ac: '',
        h_pc: '',
        category: '',
        marital_status: '',
        uan_no: '',
        aadhaar_no: '',
        training_part: '',
        specify_sub: '',
        training_exp: '',
        exp_institute: '',
        dob: '',
        doj: '',
gender: '',
father: '',
mother: '',
spouse: '',
child_son: '',
child_daughter: '',
nominee: '',
address: '',
per_address: '',
blood_grp: '',
mobile: '',
salary: '',
profile_pic: null,
        role: '',
        email: '',
        pass: '',
        pan_no: '',
        bank_name: '',
        branch_name: '',
        acc_name: '',
        ifsc_code: '',
        acc_no: '',
    });
         const imageInputRef = useRef(null);
         const [selectedFiles, setSelectedFiles] = useState([]);
         const fileInputRef = useRef(null);
          const [showUploadSheet, setShowUploadSheet] = useState(false);
const [roles, setRoles] = useState([
  'Teacher',
  'Librarian',
  'Transport',
  'Other'
]);


  const handleButtonClick = () => {
    if (imageInputRef.current) {
      imageInputRef.current.click();
    }
  };

    const handleImageChange = (event) => {
    const files = event.target.files;
    if (files.length > 200) {
      alert("You can upload a maximum of 200 Images at once.");
      return;
    }
    setSelectedFiles(files);
  };
    

    const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
      alert('Please upload an Excel file (.xlsx or .xls)');
      return;
    }

    const formData = new FormData();
    formData.append('dataSheet', file);

    try {
      setLoading(true);
      const res = await fetch('https://api.kcian.in/upload-bulk-staff', {
        method: 'POST',
        body: formData,
      });

      const data = await res.json();
      if (res.ok) {
                setResponse2({ message: data.message || 'Bulk upload successful!', status: 'success' });
      } else {
                setResponse2({ message: data.message || 'Something went wrong.', status: 'error' });        
      }
    } catch (error) {
      console.error('Error uploading:', error);
    } finally {
      setLoading(false);
              setTimeout(() => {
          setResponse2('');
        }, 2000);   
      e.target.value = '';
    }
  };



    const handleUpload = async () => {
  if (!selectedFiles.length) {
    alert("Please select files to upload.");
    return;
  }

  setLoading(true);
  const formData = new FormData();
  for (let i = 0; i < selectedFiles.length; i++) {
    formData.append('profiles', selectedFiles[i]);
  }

  try {
    const response = await fetch('https://api.kcian.in/bulk-upload-profiles', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Server error: ${response.statusText}`);
    }

    const data = await response.json();
      setLoading(false);
                    setResponse2({ message: data.message || 'Images upload successful!', status: 'success' });
              setTimeout(() => {
          setResponse2('');
        }, 2000);   
    setSelectedFiles([]);
  } catch (error) {
      setLoading(false);
    console.error('Upload failed:', error);
  }
};



 const handleChange = (e) => {
    const { name, value, files } = e.target;
      if (name === 'role' && value === '__add_new__') {
    const newRole = prompt('Enter new role');

    if (!newRole || !newRole.trim()) {
      alert('Role name cannot be empty');
      return;
    }
   const roleName = newRole.trim();

    if (!roles.includes(roleName)) {
      setRoles((prev) => [...prev, roleName]);
    }

    setFormData((prev) => ({
      ...prev,
      role: roleName
    }));

         setResponse2({ message: `Role "${roleName}" added successfully`, status: 'success' });        
   setTimeout(() => {
          setResponse2('');
        }, 2000);   
    return;
  }


    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };


   const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      for (const key in formData) {
        if (formData[key] !== null) {
          data.append(key, formData[key]);
        }
      }

      const response = await fetch('https://api.kcian.in/add-employee', {
        method: 'POST',
        body: data
      });

      if (!response.ok) {
        setResponse2({ message: 'Something went wrong. Please try again.', status: 'error' });
        throw new Error('Failed to submit employee details');
      }

      const result = await response.json();
          setResponse2({ message: data.message || 'Employee/ Staff Added Successfully', status: 'success' });
setFormData({
          name: '',
        designation: '',
        h_ac: '',
        h_pc: '',
        category: '',
        marital_status: '',
        uan_no: '',
        aadhaar_no: '',
        training_part: '',
        specify_sub: '',
        training_exp: '',
        exp_institute: '',
                dob: '',
        doj: '',
gender: '',
father: '',
mother: '',
spouse: '',
child_son: '',
child_daughter: '',
nominee: '',
address: '',
per_address: '',
blood_grp: '',
mobile: '',
salary: '',
profile_pic: null,
        role: '',
        email: '',
        pass: '',
                pan_no: '',
        bank_name: '',
        branch_name: '',
        acc_name: '',
        ifsc_code: '',
        acc_no: ''

})
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };

  return (
    <>
          <section className='py-4'>
      <div className='px-4'>

      <HeadingArea message1='Employee' message2='New Staff' />


<div className='d-md-flex justify-content-between'>
        <button className='mt-2 profile-btn2' onClick={() => window.open('https://api.kcian.in/inUploads/staff_data_format.xlsx', '_blank')}>Get Format</button>

<div>
<button
  className='mt-2 profile-btn me-3'
  onClick={() => {
    setShowUploadSheet(true);
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  }}
>
  Upload Data Sheet
</button>

      <button className='mt-2 profile-btn' onClick={handleButtonClick}>Upload Images</button>
</div>

</div>

<input
        type="file"
        multiple
        accept="image/*"
        style={{ display: 'none' }}
        ref={imageInputRef}
        onChange={handleImageChange}
      />

      {selectedFiles.length > 0 && (
        <div className='mt-3 text-end'>
          <p>{selectedFiles.length} file(s) selected</p>
          <button className="profile-btn2" onClick={handleUpload}>
            Submit Upload
          </button>
        </div>
      )}
      

      {showUploadSheet && 
<input
  type="file"
  ref={fileInputRef}
  style={{ display: 'none' }}
  onChange={handleFileChange}
/>
}


       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


                  <p className='text-center profile-heading mt-4'>Employee Form</p>

  <form onSubmit={handleSubmit}>
<div className='row'>

    <p className='fw-semibold border-bottom mb-5'><Bs1CircleFill /> Basic Information</p>

            {/* Name */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Full Name*</label>
                <input type='text' name='name' value={formData.name} onChange={handleChange} className='profile-input' required />
              </div>
            </div>

            {/* Designation */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Designation*</label>
                <input type='text' name='designation' value={formData.designation} onChange={handleChange} className='profile-input' required />
              </div>
            </div>

            {/* Role */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Role*</label>
                <select name='role' value={formData.role} onChange={handleChange} className='profile-input' required>
                  <option value=''>Select Role</option>
                 {roles.map((role) => (
    <option key={role} value={role}>
      {role}
    </option>
  ))}        
                      <option value="__add_new__">Add New Role</option>    </select>
              </div>
            </div>


            {/* Profile Picture */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Profile Picture</label>
                <input type='file' name='profile_pic' onChange={handleChange} className='profile-input' />
              </div>
            </div>


            {/* DOJ */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Date of Joining</label>
                <input type='date' name='doj' value={formData.doj} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            {/* Salary */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Salary*</label>
                <input type='number' name='salary' value={formData.salary} onChange={handleChange} className='profile-input' required />
              </div>
            </div>


           {/* Mobile */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mobile Number*</label>
                <input type='tel' name='mobile' value={formData.mobile} maxLength={10} onChange={handleChange} className='profile-input' required />
              </div>
            </div>



            {/* User ID */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Email Address</label>
                <input type='email' name='email' value={formData.email} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* Password */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Password*</label>
                <input type='password' name='pass' value={formData.pass} onChange={handleChange} className='profile-input' required />
              </div>
            </div>


            {/* Designation */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Highest Academic Qualification</label>
                <input type='text' name='h_ac' value={formData.h_ac} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            {/* Designation */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Highest Professional Qualification</label>
                <input type='text' name='h_pc' value={formData.h_pc} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Category</label>
                <select name='category' value={formData.category} onChange={handleChange} className='profile-input'>
                  <option value=''>Select Category</option>
                  <option value='General'>General</option>
                  <option value='EWS'>EWS</option>
                  <option value='OBC'>OBC</option>
                  <option value='SC'>SC</option>
                  <option value='ST'>ST</option>
                  <option value='Other'>Other</option>
                </select>
              </div>
            </div>


            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Marital Status</label>
                <select name='marital_status' value={formData.marital_status} onChange={handleChange} className='profile-input'>
                  <option value=''>Select Status</option>
                  <option value='Married'>Married</option>
                  <option value='Unmarried'>Unmarried</option>
                </select>
              </div>
            </div>


                        <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Aadhaar No</label>
                <input type='text' name='aadhaar_no' value={formData.aadhaar_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>UAN No</label>
                <input type='text' name='uan_no' value={formData.uan_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>


    <p className='fw-semibold border-bottom mb-5'><Bs2CircleFill /> Experience</p>


            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Training Particulars</label>
                <select name='training_part' value={formData.training_part} onChange={handleChange} className='profile-input'>
                  <option value=''>Select Status</option>
                  <option value='D.El.Ed'>D.El.Ed</option>
                  <option value='B.Ed'>B.Ed</option>
                  <option value='M.Ed'>M.Ed</option>
                  <option value='OTET'>OTET</option>
                  <option value='CTET'>CTET</option>
                  <option value='None'>None</option>
                </select>
              </div>
            </div>


                        <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Specify Subject</label>
                <input type='text' name='specify_sub' value={formData.specify_sub} onChange={handleChange} className='profile-input' />
              </div>
            </div>

                        <div className='mb-4 col-md-4'>
</div>


                        <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Teaching Experience (in years)</label>
                <input type='text' name='training_exp' value={formData.training_exp} onChange={handleChange} className='profile-input' />
              </div>
            </div>

                        <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Institute Name</label>
                <input type='text' name='exp_institute' value={formData.exp_institute} onChange={handleChange} className='profile-input' />
              </div>
            </div>


    <p className='fw-semibold border-bottom mb-5'><Bs3CircleFill /> Bank & PAN Info</p>


                        <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Bank Name</label>
                <input type='text' name='bank_name' value={formData.bank_name} onChange={handleChange} className='profile-input' />
              </div>
            </div>


                        <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Branch Name</label>
                <input type='text' name='branch_name' value={formData.branch_name} onChange={handleChange} className='profile-input' />
              </div>
            </div>

                        <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>IFSC Code</label>
                <input type='text' name='ifsc_code' value={formData.ifsc_code} onChange={handleChange} className='profile-input' />
              </div>
            </div>


                                    <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Account Holder Name</label>
                <input type='text' name='acc_name' value={formData.acc_name} onChange={handleChange} className='profile-input' />
              </div>
            </div>

                                    <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Account No</label>
                <input type='text' name='acc_no' value={formData.acc_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>


                                    <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>PAN No</label>
                <input type='text' name='pan_no' value={formData.pan_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>



    <p className='fw-semibold border-bottom mb-5'><Bs4CircleFill /> Other Information</p>


            {/* DOB */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Date of Birth</label>
                <input type='date' name='dob' value={formData.dob} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            {/* Gender */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Gender</label>
                <select name='gender' value={formData.gender} onChange={handleChange} className='profile-input'>
                  <option value=''>Select Gender</option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                  <option value='Other'>Other</option>
                </select>
              </div>
            </div>


            {/* Blood Group */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Blood Group</label>
                <input type='text' name='blood_grp' value={formData.blood_grp} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            {/* Father */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father's Name</label>
                <input type='text' name='father' value={formData.father} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* Mother */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother's Name</label>
                <input type='text' name='mother' value={formData.mother} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            {/* Spouse */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Spouse's Name</label>
                <input type='text' name='spouse' value={formData.spouse} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* Children Son */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Children's Name (Son)</label>
                <input type='text' name='child_son' value={formData.child_son} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            {/* Children Daughter */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Children's Name (Daughter)</label>
                <input type='text' name='child_daughter' value={formData.child_daughter} onChange={handleChange} className='profile-input' />
              </div>
            </div>


{/* nominee */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Nominee</label>
                <input type='text' name='nominee' value={formData.nominee} onChange={handleChange} className='profile-input' />
              </div>
            </div>



            {/* Address */}
            <div className='mb-4 mt-2 col-md-6'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Present Address</label>
                <textarea name='address' value={formData.address} onChange={handleChange} className='profile-input' rows='3' />
              </div>
            </div>


{/* Per Address */}
            <div className='mb-4 mt-2 col-md-6'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Permanent Address</label>
                <textarea name='per_address' value={formData.per_address} onChange={handleChange} className='profile-input' rows='3' />
              </div>
            </div>


<div className='px-2'>
       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}</div>

 <div className='col-12'>
                <button type='submit' className='profile-btn'><FaCheck /> Submit</button>
              </div>


          </div>
</form>

</div>
</section>

    </>
  )
}

export default AddNewEmployee
